/* yn-product.js (package C): the product page.
   Gallery (swipe, dots, double-tap zoom), colour and size choice, add to cart with its states, the buy bar,
   the size sheet (tables from /pages/size-guide, size finder), frequently bought together, in-stock alternatives.
   Plain JavaScript, no library. Safe on pages without a product. Re-initialises in the theme editor. */
(function () {
  'use strict';
  if (window.__ynProduct) return;
  window.__ynProduct = true;

  var doc = document;
  var html = doc.documentElement;
  var SIZES = ['18-24 months', '2-3 years', '3-4 years', '4-5 years', '5-6 years', '6-7 years'];
  var EXTRA_SIZES = ['7-8 years', '8-9 years'];   /* listed in a bundle piece's size sheet only when the piece has them (the theme leaves sold-out ones out of its data) */
  var SPRING = 'cubic-bezier(.3,1.4,.5,1)';
  var TOPS = ['t-shirts', 'sweatshirts', 'hoodies'];
  var BOTTOMS = ['shorts', 'pants'];
  var TELL = 'Tell me when it’s back';
  var FAILED = 'Couldn’t add that. Check your connection and try again.';
  var instances = [];

  /* ---------- small helpers ---------- */
  function Y() { return window.Yuno || {}; }
  /* tl = Yuno.T (the visitor's language; yn-head defines it). Named tl because T is a local name for a size table below.
     English sentence case in the call, [name] placeholders, e.g. tl('Only [n] left', { n: 3 }). Size labels are keys: tl(label) shows one, never compare with the result. */
  function tl(s, p) {
    var y = window.Yuno;
    if (y && typeof y.T === 'function') return y.T(s, p);
    s = String(s == null ? '' : s);
    if (p) for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) s = s.split('[' + k + ']').join(p[k]); }
    return s;
  }
  function cap(s) { s = String(s == null ? '' : s); return s.charAt(0).toUpperCase() + s.slice(1); }
  /* a path on this site, on the Arabic site with its /ar prefix (Yuno.config.routes.root is '/' or '/ar/') */
  function localUrl(p) {
    var c = Y().config, root = (c && c.routes && c.routes.root) || '/', base = String(root).replace(/\/+$/, '');
    p = String(p || '');
    if (!base || p.charAt(0) !== '/') return p;
    if (p === base || p.indexOf(base + '/') === 0 || p.indexOf(base + '?') === 0) return p;
    return base + p;
  }
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function reduced() {
    return html.classList.contains('yn-reduced') || !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function upgrades() { return html.classList.contains('yn-upgrades') && !reduced(); }
  function money(c) {
    var y = Y();
    if (y.money) return y.money(c);
    return 'LE ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
  }
  function waUrl(text, num) {
    var y = Y();
    if (y.wa) return y.wa(text);
    return 'https://wa.me/' + ((y.config && y.config.whatsapp) || num || '201044141173') + '?text=' + encodeURIComponent(text);
  }
  function norm(v) {
    var y = Y();
    if (y.normSize) return y.normSize(v);
    var s = String(v == null ? '' : v).toLowerCase().replace(/\s*[-–—]\s*/g, '-').replace(/\s+/g, ' ').trim();
    if (s === '12-24 months') s = '18-24 months';
    return SIZES.indexOf(s) > -1 ? s : '';
  }
  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function idle(fn, ms) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: ms || 2500 });
    else setTimeout(fn, Math.min(ms || 2500, 900));
  }
  function mk(tag, cls, text) {
    var e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function pop(el, big) {
    if (!el || reduced() || !el.animate) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(' + (big || 1.3) + ')' }, { transform: 'scale(1)' }], { duration: 360, easing: SPRING });
  }
  function pillPop(el) {
    if (!el || reduced() || !el.animate) return;
    el.animate([{ transform: 'scale(.94) rotate(0deg)' }, { transform: 'scale(1.04) rotate(-1deg)' }, { transform: 'scale(1) rotate(-1deg)' }], { duration: 180, easing: SPRING });
  }
  function shake(el, px) {
    if (!el || reduced() || !el.animate) return;
    var d = px || 3;
    el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-d) + 'px)' }, { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(' + (-d) + 'px)' }, { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(0)' }], { duration: 320, easing: 'ease-in-out' });
  }
  function toast(msg) {
    var y = Y();
    if (y.toast) y.toast(msg);
  }
  function remembered() {
    var y = Y(), v = null;
    try { if (y.size && y.size.get) v = y.size.get(); } catch (e) {}
    if (!v) {
      try {
        var raw = localStorage.getItem('yuno-age');
        if (raw) { try { v = JSON.parse(raw); } catch (e2) { v = raw; } }
      } catch (e3) {}
    }
    v = norm(v);
    return v || null;
  }
  function cartTarget() {
    var list = $$('[data-yn-cart-open]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i], r = el.getBoundingClientRect(), cs = window.getComputedStyle(el);
      if (r.width && r.height && cs.visibility !== 'hidden' && cs.display !== 'none' && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth) return el;
    }
    return null;
  }
  function popCounts() { $$('[data-yn-cart-count]').forEach(function (c) { if (!c.hidden) pop(c, 1.45); }); }
  function flyTo(fromEl, src) {
    if (!upgrades() || !fromEl || !src || !fromEl.animate) return Promise.resolve();
    var target = cartTarget();
    if (!target) return Promise.resolve();
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect(), S = 56;
    var img = doc.createElement('img');
    img.src = src; img.alt = '';
    img.style.cssText = 'position:fixed;z-index:200;pointer-events:none;border-radius:12px;object-fit:cover;box-shadow:0 8px 20px rgba(31,42,68,.25);left:' + (a.left + a.width / 2 - S / 2) + 'px;top:' + (a.top + a.height / 2 - S * 0.625) + 'px;width:' + S + 'px;height:' + (S * 1.25) + 'px';
    doc.body.appendChild(img);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var lift = Math.min(-60, dy * 0.5 - 80);
    var an = img.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + lift + 'px) scale(.8) rotate(-8deg)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25) rotate(4deg)', opacity: 0.6 }
    ], { duration: 450, easing: 'cubic-bezier(.4,.1,.6,1)', fill: 'forwards' });
    var done = function () { if (img.parentNode) img.parentNode.removeChild(img); };
    return an.finished.then(done, done);
  }
  function cleanHtml(str) {
    var s = String(str || '');
    if (!/<p[\s>]/i.test(s)) s = '<p>' + s + '</p>';
    var frag = doc.createDocumentFragment();
    var d = new DOMParser().parseFromString('<div>' + s + '</div>', 'text/html');
    var allowed = { P: 1, STRONG: 1, B: 1, EM: 1, I: 1, BR: 1 };
    (function walk(src, dst) {
      Array.prototype.forEach.call(src.childNodes, function (n) {
        if (n.nodeType === 3) dst.appendChild(doc.createTextNode(n.nodeValue));
        else if (n.nodeType === 1) {
          if (allowed[n.tagName]) { var c = doc.createElement(n.tagName.toLowerCase()); walk(n, c); dst.appendChild(c); }
          else walk(n, dst);
        }
      });
    })(d.body.firstChild, frag);
    return frag;
  }

  /* ================================================================== */
  function init(root) {
    if (root.__ynInit) return;
    var dataEl = $('[data-yn-data]', root);
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__ynInit = true;

    var low = parseInt(root.getAttribute('data-low'), 10) || 5;
    var isEG = root.getAttribute('data-eg') === 'true';
    var waNum = root.getAttribute('data-wa') || '201044141173';
    var cleanups = [];
    function listen(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    /* ---------- elements ---------- */
    var form = $('.yn-pdp__form', root);
    var mainCta = $('.yn-pdp__cta', root);
    var mainBtn = $('[data-yn-main-btn]', root);
    var mainWa = $('[data-yn-main-wa]', root);
    var mainLbl = $('[data-yn-add-label]', root);
    var idInput = $('[data-yn-id]', root);
    var errEl = $('[data-yn-err]', root);
    var statusEl = $('[data-yn-status]', root);
    var sizeLine = $('[data-yn-sizeline]', root);
    var pillsWrap = $('[data-yn-pills]', root);
    var bar = $('[data-yn-buybar]', root);
    var barCta = $('.yn-buybar__cta', root);
    var barBtn = $('[data-yn-bar-btn]', root);
    var barWa = $('[data-yn-bar-wa]', root);
    var barSize = $('[data-yn-bar-size]', root);
    var barSizeLbl = $('[data-yn-bar-size-label]', root);
    var barLbl = $('[data-yn-bar-label]', root);
    var sheet = doc.getElementById('yn-sheet-size');
    var hasSize = D.sizePos > 0 && !!pillsWrap;
    var sizeHelp = sizeLine ? (sizeLine.getAttribute('data-help') || '') : '';
    var tabsKeys = ((sheet && sheet.getAttribute('data-tabs')) || D.kind || 't-shirts').split('|');
    var sizeUrl = localUrl((sheet && sheet.getAttribute('data-size-url')) || '/pages/size-guide');
    var tablesKey = 'yn-size-tables' + ((Y().config && Y().config.ar) ? '-ar' : '');   /* the Arabic page has its own tables, so its cache is kept apart */
    var presentSizes = hasSize ? $$('[data-yn-size]', pillsWrap).map(function (b) { return b.getAttribute('data-yn-size'); }) : [];

    /* ---------- state ---------- */
    var st = { colour: null, size: null, others: {}, phase: 'idle', src: null, busy: false, err: '', pending: null, pendingSrc: null };
    var cp = $('[data-yn-colour][aria-pressed="true"]', root);
    if (cp) st.colour = cp.getAttribute('data-yn-colour');
    else if (D.colourPos && D.colours && D.colours.length) st.colour = D.colours[0].v;
    var sp = hasSize ? $('[data-yn-size][aria-pressed="true"]', pillsWrap) : null;
    if (sp) st.size = sp.getAttribute('data-yn-size');
    $$('[data-yn-opt]', root).forEach(function (g) {
      var pr = $('[aria-pressed="true"]', g);
      if (pr) st.others[g.getAttribute('data-yn-opt')] = pr.getAttribute('data-yn-optval');
    });
    var cur = null, selOut = false, canBuy = false;

    function colourMatch(v, colour) { return !D.colourPos || v.o[D.colourPos - 1] === colour; }
    function othersMatch(v) {
      for (var pos in st.others) { if (v.o[pos - 1] !== st.others[pos]) return false; }
      return true;
    }
    function variantsOf(size, colour) {
      return D.variants.filter(function (v) {
        return (!hasSize || v.s === size) && colourMatch(v, colour) && othersMatch(v);
      });
    }
    function statusOf(size, colour) {
      var vs = variantsOf(size, colour === undefined ? st.colour : colour);
      var av = vs.filter(function (v) { return v.a; });
      if (av.length) {
        var v = av[0];
        return { out: false, left: (v.q != null && v.q >= 1 && v.q <= low) ? v.q : null, v: v };
      }
      return { out: true, left: null, v: vs[0] || null };
    }
    function recompute() {
      if (hasSize) {
        if (st.size) { var s = statusOf(st.size); cur = s.v; selOut = s.out; canBuy = !s.out && !!cur; }
        else { cur = null; selOut = false; canBuy = false; }
      } else {
        var vs = variantsOf(null, st.colour);
        var av = vs.filter(function (v) { return v.a; });
        cur = av[0] || vs[0] || null;
        selOut = false;
        canBuy = !!(cur && cur.a);
      }
    }
    function announce(t) { if (statusEl) { statusEl.textContent = ''; setTimeout(function () { statusEl.textContent = t; }, 30); } }

    /* ---------- size tables (contract 9) ---------- */
    var tables = null, tablesState = 'idle', tablesP = null, otherTab = null;
    function tabByKey(k) { return tables && tables.tabs ? tables.tabs.filter(function (t) { return t.key === k; })[0] : null; }
    /* The size-guide page prints its headers already in the page's language ("Waist (cm)", on /ar "الوسط (سم)"). The script never reads their words:
       columns are found by position (rows[0] is the size key, the last two columns are shown in the size line). This only drops the unit in brackets
       at the end, so the size line can say "Waist 24 cm". */
    function cleanCol(c) { return String(c).replace(/\s*\([^)]*\)\s*$/, '').trim(); }
    function measureFor(label) {
      if (!tables) return '';
      var tab = tabByKey(tabsKeys[0]);
      if (!tab || !tab.tables || !tab.tables[0]) return '';
      var T = tab.tables[0];
      var row = T.rows.filter(function (r) { return norm(r[0]) === label; })[0];
      if (!row) return '';
      var cols = T.columns.slice(1), vals = row.slice(1), out = [];
      for (var i = Math.max(0, cols.length - 2); i < cols.length; i++) {
        if (vals[i] != null && vals[i] !== '') out.push(tl('[a] [b] cm', { a: tl(cleanCol(cols[i])), b: vals[i] }));
      }
      return out.join(' · ');
    }
    function loadTables() {
      if (tablesP) return tablesP;
      tablesP = new Promise(function (resolve) {
        var cached = null;
        try { cached = sessionStorage.getItem(tablesKey); } catch (e) {}
        if (cached) {
          try { tables = JSON.parse(cached); tablesState = 'ok'; return resolve(tables); } catch (e2) {}
        }
        tablesState = 'loading';
        fetch(sizeUrl, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('size guide'); return r.text(); })
          .then(function (txt) {
            var d = new DOMParser().parseFromString(txt, 'text/html');
            var s = d.getElementById('yn-size-tables');
            if (!s) throw new Error('no tables');
            var j = JSON.parse(s.textContent);
            if (!j || !j.tabs) throw new Error('bad tables');
            try { sessionStorage.setItem(tablesKey, JSON.stringify(j)); } catch (e3) {}
            tables = j; tablesState = 'ok'; resolve(j);
          })
          .catch(function () { tablesState = 'fail'; resolve(null); });
      }).then(function (j) { render(); if (sheet && sheet.getAttribute('data-mode') === 'guide') renderGuide(); return j; });
      return tablesP;
    }

    /* ---------- the size line ---------- */
    function lineInfo() {
      if (!hasSize) return null;
      if (!st.size) return { text: sizeHelp, out: false };
      var s = statusOf(st.size);
      if (s.out) return { text: tl('This size is sold out. We’ll tell you on WhatsApp when it’s back.'), out: true };
      var m = measureFor(st.size);
      var head = m ? tl('[a]: [b]', { a: tl(st.size), b: m }) : tl(st.size);
      return { text: head + (s.left ? ' · ' + tl('Only [n] left', { n: s.left }) : ''), out: false };
    }
    function tellHref() {
      return waUrl('Hi Yuno! Please tell me when "' + D.title + '"' + (st.size ? ' in ' + st.size : '') + ' is back.', waNum);
    }

    /* ---------- pills ---------- */
    function paintPill(b) {
      var label = b.getAttribute('data-yn-size');
      var s = statusOf(label);
      b.setAttribute('aria-pressed', st.size === label ? 'true' : 'false');
      b.classList.toggle('is-soldout', s.out);
      b.classList.toggle('is-low', !s.out && !!s.left);
      var srEl = $('[data-yn-pill-sr]', b), lowEl = $('[data-yn-pill-low]', b);
      if (srEl) srEl.textContent = s.out ? tl(', sold out') : '';
      if (lowEl) { lowEl.hidden = !(!s.out && s.left); lowEl.textContent = (!s.out && s.left) ? tl('[n] left', { n: s.left }) : ''; }
    }
    function makePill(label) {
      var b = mk('button', 'yn-pill yn-sz__pill');
      b.type = 'button';
      b.setAttribute('data-yn-size', label);
      b.setAttribute('aria-pressed', 'false');
      b.appendChild(doc.createTextNode(tl(label)));
      var sr = mk('span', 'yn-vh'); sr.setAttribute('data-yn-pill-sr', ''); b.appendChild(sr);
      var lo = mk('span', 'yn-pdp__low'); lo.setAttribute('data-yn-pill-low', ''); lo.hidden = true; b.appendChild(lo);
      return b;
    }
    var sheetPillsWrap = sheet ? $('[data-yn-sheet-pills]', sheet) : null;
    if (sheetPillsWrap) presentSizes.forEach(function (l) { sheetPillsWrap.appendChild(makePill(l)); });

    /* ---------- render ---------- */
    function labelFor(src) {
      if (!hasSize) return canBuy ? tl('Add to cart') : tl('Sold out');
      if (src === 'bar') return !st.size ? tl('Choose size') : selOut ? tl(TELL) : tl('Add to cart');
      return selOut ? tl(TELL) : (!D.available && !st.size) ? tl('Choose a size') : tl('Add to cart');
    }
    function phaseLabel(src, base) {
      if (st.src !== src) return base;
      if (st.phase === 'loading') return '';
      if (st.phase === 'success') return tl('Added!');
      if (st.phase === 'error') return tl('Try again');
      return base;
    }
    function render() {
      recompute();
      /* colour */
      $$('[data-yn-colour]', root).forEach(function (b) {
        var val = b.getAttribute('data-yn-colour');
        var out = !D.variants.some(function (v) { return v.o[D.colourPos - 1] === val && v.a; });
        b.setAttribute('aria-pressed', val === st.colour ? 'true' : 'false');
        b.classList.toggle('is-soldout', out);
        b.setAttribute('aria-label', out ? tl('[n], sold out', { n: val }) : val);
      });
      var cn = $('[data-yn-colour-name]', root);
      if (cn) cn.textContent = st.colour || '';
      $$('[data-yn-opt]', root).forEach(function (g) {
        var pos = g.getAttribute('data-yn-opt');
        $$('[data-yn-optval]', g).forEach(function (b) { b.setAttribute('aria-pressed', st.others[pos] === b.getAttribute('data-yn-optval') ? 'true' : 'false'); });
      });
      /* pills (page and sheet) */
      if (pillsWrap) $$('[data-yn-size]', pillsWrap).forEach(paintPill);
      if (sheetPillsWrap) $$('[data-yn-size]', sheetPillsWrap).forEach(paintPill);
      /* size line */
      var li = lineInfo();
      if (li && sizeLine) { sizeLine.textContent = li.text; sizeLine.classList.toggle('is-out', li.out); }
      var sLine = sheet ? $('[data-yn-sheet-line]', sheet) : null;
      var sWa = sheet ? $('[data-yn-sheet-wa]', sheet) : null;
      if (sLine && li) { sLine.textContent = st.size ? li.text : sizeHelp; sLine.classList.toggle('is-out', li.out); }
      if (sWa) { sWa.hidden = !(li && li.out); if (li && li.out) sWa.href = tellHref(); }
      /* highlighted row in the size guide */
      if (sheet) $$('.yn-sz__table tr[data-size]', sheet).forEach(function (tr) { tr.classList.toggle('is-on', !!st.size && tr.getAttribute('data-size') === st.size); });
      /* main button */
      var showWa = !!(hasSize && st.size && selOut);
      if (mainBtn) {
        mainBtn.hidden = showWa;
        mainBtn.disabled = !hasSize && !canBuy;
        mainBtn.setAttribute('aria-busy', st.busy && st.src === 'main' ? 'true' : 'false');
      }
      if (mainWa) { mainWa.hidden = !showWa; if (showWa) mainWa.href = tellHref(); }
      if (mainLbl) mainLbl.textContent = phaseLabel('main', labelFor('main'));
      if (mainCta) mainCta.setAttribute('data-phase', st.src === 'main' ? st.phase : 'idle');
      /* buy bar */
      if (bar) {
        if (barSize) {
          barSize.hidden = !(hasSize && st.size);
          if (st.size) { barSizeLbl.textContent = tl(st.size); barSize.setAttribute('aria-label', tl('Change size, [n]', { n: tl(st.size) })); }
        }
        if (barBtn) barBtn.hidden = showWa;
        if (barWa) { barWa.hidden = !showWa; if (showWa) barWa.href = tellHref(); }
        if (barCta) { barCta.classList.toggle('is-wa', showWa); barCta.setAttribute('data-phase', st.src === 'bar' ? st.phase : 'idle'); }
        if (barLbl) barLbl.textContent = phaseLabel('bar', labelFor('bar'));
        if (barBtn) barBtn.disabled = !hasSize && !canBuy;
      }
      /* hidden id for the plain form fallback */
      if (idInput) { idInput.value = cur ? cur.id : ''; idInput.disabled = !(cur && cur.a); }
      /* error line */
      if (errEl) errEl.textContent = (st.phase === 'error' && (st.src === 'main' || st.src === 'bar')) ? st.err : '';
      updatePrice();
      if (bundle) bundle.refresh();
    }
    /* the price block is rendered by yn-price; only touch it when this product's variants have different prices */
    var priceVaries = D.variants.some(function (v) { return v.p !== D.variants[0].p || v.c !== D.variants[0].c; });
    function updatePrice() {
      if (!cur || !priceVaries) return;
      $$('.yn-price', root).forEach(function (p) {
        var now = $('.yn-price__now', p), was = $('.yn-price__was', p);
        if (now && now.textContent.trim() !== money(cur.p)) now.textContent = money(cur.p);
        if (was && cur.c > cur.p && was.textContent.trim() !== money(cur.c)) was.textContent = money(cur.c);
      });
    }
    function clearError() { if (st.phase === 'error') { st.phase = 'idle'; st.src = null; st.err = ''; } }
    function syncUrl() {
      if (!cur || !hasSize || !st.size) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', cur.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }

    /* ---------- colour and size choice ---------- */
    function setColour(val, btn) {
      if (st.colour === val) return;
      clearError();
      st.colour = val;
      render();
      if (btn) {
        pop(btn.querySelector('.yn-pdp__sw-dot'), 1.12);
        var ring = btn.querySelector('.yn-pdp__sw-ring');
        if (ring && !reduced() && ring.animate) ring.animate([{ transform: 'scale(.6) rotate(-40deg)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: SPRING });
      }
      scrollToColour(val);
      syncUrl();
      updateAlts();
    }
    function pickSize(label, el, fromSheet) {
      clearError();
      st.size = label;
      render();
      var s = statusOf(label);
      if (el) { if (s.out) shake(el, 3); else pillPop(el); }
      if (s.out) announce(tl('This size is sold out'));
      syncUrl();
      updateAlts();
      if (!fromSheet || s.out) return;
      var pend = st.pending, src = st.pendingSrc || 'bar';
      st.pending = null; st.pendingSrc = null;
      setTimeout(function () {
        closeSheet();
        if (pend === 'add') setTimeout(function () { onMain(src); }, 300);
        else if (pend === 'bundle' && bundle) setTimeout(function () { bundle.add(); }, 300);
      }, 220);
    }

    /* ---------- the sheet ---------- */
    function setMode(m) {
      if (!sheet) return;
      sheet.setAttribute('data-mode', m);
      $$('[data-yn-pane]', sheet).forEach(function (p) { p.hidden = p.getAttribute('data-yn-pane') !== m; });
      var t = $('[data-yn-size-title]', sheet);
      if (t) t.textContent = m === 'guide' ? tl('Size guide') : tl('Choose a size');
      var body = $('.yn-sheet__body', sheet);
      if (body) body.scrollTop = 0;
      if (m === 'guide') { renderGuide(); renderFinder(); }
    }
    function openSheet(m) {
      if (!sheet) { if (m === 'guide') window.location.href = sizeUrl; return; }
      setMode(m);
      var y = Y();
      if (y.sheet && y.sheet.open) y.sheet.open('yn-sheet-size');
      else if (m === 'guide') window.location.href = sizeUrl;
      if (m === 'guide') loadTables();
    }
    function closeSheet() { var y = Y(); if (y.sheet && y.sheet.close) y.sheet.close('yn-sheet-size'); }
    if (sheet && !reduced()) sheet.classList.add('is-drawing');

    /* size guide: tables */
    function tableCard(tab, T, showHow) {
      var card = mk('div', 'yn-sz__card');
      var head = mk('span', 'yn-sz__tlabel', tl(T.label || tab.title || cap(tab.key)));
      if (T.unconfirmed) head.appendChild(mk('span', 'yn-sz__tag', tl('To be confirmed')));
      card.appendChild(head);
      var table = mk('table', 'yn-sz__table');
      var thead = mk('thead'), hr = mk('tr');
      (T.columns || []).forEach(function (c, i) { hr.appendChild(mk('th', '', c ? tl(c) : (i === 0 ? tl('Size') : ''))); });
      thead.appendChild(hr); table.appendChild(thead);
      var tb = mk('tbody');
      (T.rows || []).forEach(function (r) {
        var tr = mk('tr'), sz = norm(r[0]);
        tr.setAttribute('data-size', sz);
        if (st.size && sz === st.size) tr.className = 'is-on';
        r.forEach(function (c, i) { tr.appendChild(mk('td', '', i === 0 ? tl(sz || c) : c)); });
        tb.appendChild(tr);
      });
      table.appendChild(tb); card.appendChild(table);
      if (showHow && tab.how) { var how = mk('div', 'yn-sz__howto'); how.appendChild(cleanHtml(tab.how)); card.appendChild(how); }
      return card;
    }
    function renderGuide() {
      if (!sheet) return;
      var host = $('[data-yn-tables]', sheet);
      if (!host) return;
      host.textContent = '';
      if (tablesState === 'idle' || tablesState === 'loading') {
        host.appendChild(mk('p', 'yn-sz__loading', tl('Loading sizes…')));
        loadTables();
        return;
      }
      var keys = otherTab ? [otherTab] : tabsKeys;
      if (tables) {
        keys.forEach(function (k) {
          var tab = tabByKey(k);
          if (!tab) return;
          (tab.tables || []).forEach(function (T, i, arr) { host.appendChild(tableCard(tab, T, i === arr.length - 1)); });
        });
      }
      if (!host.children.length) {
        var p = mk('p', 'yn-sz__fail'), a = mk('a', '', tl('Open the size guide'));
        a.href = sizeUrl; p.appendChild(a); host.appendChild(p);
      }
      var k0 = keys[0], shape = k0 === 'shorts' ? 'shorts' : k0 === 'pants' ? 'pants' : 'tee';
      $$('[data-yn-shape]', sheet).forEach(function (s) { if (s.getAttribute('data-yn-shape') !== shape) s.setAttribute('hidden', ''); else s.removeAttribute('hidden'); });
      $$('[data-yn-tab]', sheet).forEach(function (c) { c.setAttribute('aria-pressed', otherTab === c.getAttribute('data-yn-tab') ? 'true' : 'false'); });
    }

    /* size finder (a helper; the height rule is a sample until the owner confirms it) */
    var finder = { age: 0, h: '' };
    function finderSuggest() {
      if (!finder.age) return '';
      var hs = ((sheet && sheet.getAttribute('data-heights')) || '').split(',').map(function (x) { return parseInt(x, 10); });
      if (hs.length !== 6 || hs.some(isNaN)) hs = [86, 95, 103, 110, 116, 122];
      var base = Math.min(5, Math.max(0, finder.age - 1)), h = parseInt(finder.h, 10), i = base;
      if (h && h > hs[base] + 5) i = Math.min(5, base + 1);
      if (h && h < hs[base] - 8) i = Math.max(0, base - 1);
      return SIZES[i];
    }
    function renderFinder() {
      if (!sheet) return;
      var box = $('[data-yn-finder]', sheet);
      if (!box) return;
      var sug = finderSuggest(), offered = sug && presentSizes.indexOf(sug) > -1;
      $$('[data-yn-age]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-yn-age')) === String(finder.age) ? 'true' : 'false'); });
      $('[data-yn-finder-out]', box).textContent = sug ? tl('We’d pick [n]', { n: tl(sug) }) : tl('Tell us their age to get a suggestion');
      $('[data-yn-finder-use]', box).hidden = !offered;
      var note = $('[data-yn-finder-note]', box);
      note.hidden = !(sug && !offered);
      if (sug && !offered) note.textContent = tl('This piece doesn’t come in [n].', { n: tl(sug) });
    }

    /* ---------- gallery ---------- */
    var track = $('[data-yn-track]', root);
    var slides = track ? $$('[data-slide]', track) : [];
    var gi = 0;
    function hoverZoom() { return !!(window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches); }
    function resetZoom() { slides.forEach(function (s) { if (s.__zoomOff) s.__zoomOff(); }); }
    function goSlide(slide, smooth) {
      if (!track || !slide) return;
      resetZoom();
      var cs = window.getComputedStyle(track), rtl = cs.direction === 'rtl';
      var pad = parseFloat(rtl ? cs.paddingRight : cs.paddingLeft) || 0;
      var tr = track.getBoundingClientRect(), sr = slide.getBoundingClientRect();
      var delta = rtl ? (sr.right - tr.right + pad) : (sr.left - tr.left - pad);
      if (typeof track.scrollBy === 'function') track.scrollBy({ left: delta, behavior: (smooth === false || reduced()) ? 'auto' : 'smooth' });
      else track.scrollLeft += delta;
    }
    function scrollToColour(val) {
      if (!D.colourPos) return;
      var vs = D.variants.filter(function (v) { return v.o[D.colourPos - 1] === val && v.m; });
      if (!vs.length) return;
      var pick = vs.filter(function (v) { return v.s === st.size; })[0] || vs[0];
      goSlide($('[data-media-id="' + pick.m + '"]', track));
    }
    function setGi(i) {
      gi = i;
      $$('.yn-gal__dot', root).forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      $$('[data-yn-thumb]', root).forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var gs = $('[data-yn-gal-status]', root);
      if (gs && slides.length > 1) gs.textContent = (i + 1) + ' / ' + slides.length;
    }
    if (track) {
      var ticking = false;
      listen(track, 'scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (!slides[0]) return;
          var step = slides[0].offsetWidth + 8, sl = Math.abs(track.scrollLeft);
          var i = Math.round(sl / step);
          if (sl + track.clientWidth >= track.scrollWidth - 2) i = slides.length - 1;
          i = clamp(i, 0, slides.length - 1);
          if (i !== gi) setGi(i);
        });
      }, { passive: true });
      slides.forEach(function (sl) {
        var img = sl.querySelector('.yn-gal__img');
        if (!img) return;
        var z = null, last = 0, drag = null, moved = false;
        function apply(animate) {
          img.classList.toggle('is-animating', !!animate && !reduced());
          img.style.transform = z ? 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')' : '';
        }
        function off() { if (!z) return; z = null; sl.classList.remove('is-zoomed'); track.classList.remove('is-zoom'); apply(true); }
        sl.__zoomOff = off;
        function toggle(e) {
          if (z) { off(); return; }
          var r = sl.getBoundingClientRect(), s = 2.2, px = e.clientX - r.left, py = e.clientY - r.top;
          z = { s: s, tx: clamp((1 - s) * px, (1 - s) * r.width, 0), ty: clamp((1 - s) * py, (1 - s) * r.height, 0) };
          sl.classList.add('is-zoomed'); track.classList.add('is-zoom'); apply(true);
        }
        listen(sl, 'pointerdown', function (e) {
          if (!z) return;
          drag = { x: e.clientX, y: e.clientY, tx: z.tx, ty: z.ty }; moved = false;
          try { sl.setPointerCapture(e.pointerId); } catch (x) {}
        });
        listen(sl, 'pointermove', function (e) {
          if (e.pointerType === 'mouse' && hoverZoom()) {
            var r0 = sl.getBoundingClientRect();
            sl.style.setProperty('--zx', ((e.clientX - r0.left) / r0.width * 100) + '%');
            sl.style.setProperty('--zy', ((e.clientY - r0.top) / r0.height * 100) + '%');
            return;
          }
          if (!drag || !z) return;
          var r = sl.getBoundingClientRect(), dx = e.clientX - drag.x, dy = e.clientY - drag.y;
          if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
          z.tx = clamp(drag.tx + dx, (1 - z.s) * r.width, 0);
          z.ty = clamp(drag.ty + dy, (1 - z.s) * r.height, 0);
          apply(false);
        });
        listen(sl, 'pointerup', function (e) {
          drag = null;
          if (hoverZoom()) return;
          if (moved) { moved = false; return; }
          if (e.target.closest && e.target.closest('button, a, video, iframe')) return;
          var now = Date.now();
          if (now - last < 300) { toggle(e); last = 0; } else last = now;
        });
        listen(sl, 'pointercancel', function () { drag = null; });
      });
    }

    /* ---------- add to cart ---------- */
    function btnFor(src) { return src === 'bar' ? (barCta || barBtn) : src === 'bundle' ? $('[data-yn-fbt-add]', root) : (mainBtn && !mainBtn.hidden ? mainBtn : mainWa); }
    function imageFor(items) {
      if (items.length && cur && items[0].id === cur.id && cur.img) return cur.img;
      return D.image;
    }
    function nativeSubmit(items) {
      if (!form || !idInput) return;
      idInput.disabled = false; idInput.value = items[0].id;
      form.submit();
    }
    function add(items, src) {
      if (st.busy) return Promise.resolve(false);
      st.busy = true; st.src = src; st.phase = 'loading'; st.err = '';
      render(); announce(tl('Adding to cart'));
      var t0 = Date.now(), y = Y();
      if (!(y.cart && y.cart.add)) { nativeSubmit(items); return Promise.resolve(true); }
      return y.cart.add(items, { source: 'product' }).then(function () {
        return delay(Math.max(0, 220 - (Date.now() - t0)));
      }).then(function () {
        st.phase = 'success'; render(); announce(tl('Added to cart'));
        try { flyTo(btnFor(src), imageFor(items)).then(popCounts); if (!upgrades()) popCounts(); } catch (e) {}
        return delay(600);
      }).then(function () {
        st.phase = 'idle'; st.src = null; st.busy = false; render();
        var y2 = Y();
        if (y2.cart && y2.cart.open) y2.cart.open();
        return true;
      }, function (err) {
        st.busy = false; st.phase = 'error'; st.src = src;
        st.err = (err && (err.message || (typeof err === 'string' ? err : ''))) || tl(FAILED);
        render(); announce(st.err); shake(btnFor(src), 4);
        return false;
      });
    }
    function onMain(src) {
      if (st.busy) return;
      if (!hasSize) { if (canBuy) add([{ id: cur.id, quantity: 1 }], src); return; }
      if (!st.size) { st.pending = 'add'; st.pendingSrc = src; openSheet('pick'); return; }
      if (selOut) { window.open(tellHref(), '_blank', 'noopener'); return; }
      if (cur && cur.a) add([{ id: cur.id, quantity: 1 }], src);
    }
    if (form) listen(form, 'submit', function (e) { e.preventDefault(); onMain('main'); });
    if (barBtn) listen(barBtn, 'click', function () { onMain('bar'); });

    /* ---------- the buy bar steps aside while the main button is on screen ---------- */
    var barIO = null;
    function setAway(away) {
      if (!bar) return;
      bar.classList.toggle('is-away', away);
      bar.setAttribute('aria-hidden', away ? 'true' : 'false');
      if ('inert' in bar) bar.inert = away;
    }
    if (bar && (mainCta || mainBtn) && 'IntersectionObserver' in window) {
      barIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { setAway(e.isIntersecting); });
      }, { threshold: 0.5 });
      barIO.observe(mainCta || mainBtn);
    }

    /* ---------- share, rating, estimate ---------- */
    var shareBtn = $('[data-yn-share]', root);
    if (shareBtn) listen(shareBtn, 'click', function () {
      var u = window.location.href.split('#')[0];
      if (navigator.share) { navigator.share({ title: D.title, url: u }).catch(function () {}); return; }
      var done = function () { toast(tl('Link copied')); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done, function () {});
      else {
        var ta = mk('textarea'); ta.value = u; ta.style.cssText = 'position:fixed;opacity:0'; doc.body.appendChild(ta); ta.select();
        try { doc.execCommand('copy'); done(); } catch (e) {}
        doc.body.removeChild(ta);
      }
    });
    var ratingEl = $('[data-yn-rating]', root);
    if (ratingEl) listen(ratingEl, 'click', function (e) {
      if (e.defaultPrevented) return;
      var target = doc.getElementById('yn-reviews'), y0 = window.pageYOffset;
      if (!target) return;
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - y0) < 10) target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      }, 120);
    });
    var eta = $('[data-yn-eta]', root);
    if (eta) {
      /* data-days is the Delivery time setting exactly as typed (English, never translated): the two numbers come from it.
         The visible sentence is built with tl and placeholders; the Arabic page writes the dates in Arabic (Latin digits). */
      var days = String(root.getAttribute('data-days') || '2–3 working days').replace(/[٠-٩]/g, function (ch) { return ch.charCodeAt(0) - 0x0660; });
      var mm = days.match(/(\d+)\D+(\d+)/), da = mm ? +mm[1] : 2, db = mm ? +mm[2] : 3;
      var addWork = function (n) {
        var x = new Date();
        while (n > 0) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 5 && wd !== 6) n--; }
        return x;
      };
      var etaLocale = (Y().config && Y().config.ar) ? 'ar-EG-u-nu-latn' : 'en-GB';
      var fmt = function (d) {
        try {
          var parts = {};
          new Intl.DateTimeFormat(etaLocale, { weekday: 'short', day: 'numeric', month: 'short' }).formatToParts(d).forEach(function (p) { parts[p.type] = p.value; });
          return parts.weekday + ' ' + parts.day + ' ' + parts.month;
        } catch (e) { return d.toDateString(); }
      };
      $('[data-yn-eta-text]', eta).textContent = tl('Get it between [a] and [b]', { a: fmt(addWork(da)), b: fmt(addWork(db)) });
      eta.hidden = false;
    }

    /* ---------- recommendations (one request serves the bundle and the alternatives) ---------- */
    var recsP = null;
    function getRecs() {
      if (recsP) return recsP;
      var url = root.getAttribute('data-recs-url'), sid = root.getAttribute('data-section-id');
      if (!url || !sid) { recsP = Promise.resolve({ list: [], cards: {} }); return recsP; }
      recsP = fetch(url + '?section_id=' + encodeURIComponent(sid) + '&product_id=' + D.id + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('recs'); return r.text(); })
        .then(function (txt) {
          var d = new DOMParser().parseFromString(txt, 'text/html');
          var j = d.querySelector('[data-yn-recs-json]'), list = [], cards = {};
          if (j) { try { list = JSON.parse(j.textContent).filter(Boolean); } catch (e) {} }
          $$('[data-yn-recs-cards] [data-yn-card]', d).forEach(function (c) { cards[c.getAttribute('data-handle')] = c; });
          return { list: list, cards: cards };
        })
        .catch(function () { return { list: [], cards: {} }; });
      return recsP;
    }

    /* ---------- in-stock alternatives ---------- */
    var altsEl = $('[data-yn-alts]', root), altsToken = 0;
    function updateAlts() {
      if (!altsEl) return;
      var bySize = !!(hasSize && st.size && selOut);
      if (D.available && !bySize) { altsEl.hidden = true; return; }
      var token = ++altsToken;
      getRecs().then(function (r) {
        if (token !== altsToken) return;
        var items = r.list.filter(function (p) {
          if (!p.available || p.id === D.id) return false;
          if (!bySize) return true;
          var card = r.cards[p.handle];
          return !!card && (card.getAttribute('data-sizes') || '').split('|').indexOf(st.size) > -1;
        });
        items.sort(function (a, b) { return (b.kind === D.kind ? 1 : 0) - (a.kind === D.kind ? 1 : 0); });
        items = items.slice(0, 3);
        var grid = $('[data-yn-alts-grid]', altsEl);
        grid.textContent = '';
        items.forEach(function (p) { var c = r.cards[p.handle]; if (c) grid.appendChild(c.cloneNode(true)); });
        if (!grid.children.length) { altsEl.hidden = true; return; }
        $('[data-yn-alts-title]', altsEl).textContent = bySize ? tl('In stock in [n]', { n: tl(st.size) }) : tl('In stock now');
        altsEl.hidden = false;
      });
    }

    /* ---------- frequently bought together ---------- */
    var fbt = $('[data-yn-fbt]', root);
    var bundle = fbt ? makeBundle() : null;

    function makeBundle() {
      var rowEl = $('[data-yn-fbt-row]', fbt), addBtn = $('[data-yn-fbt-add]', fbt), lbl = $('[data-yn-fbt-label]', fbt), note = $('[data-yn-fbt-note]', fbt);
      var bsheet = doc.getElementById('yn-sheet-bundle');
      var pieces = [], drawn = false;
      var bs = { o: null, colour: null, size: null };

      function tickSvg() {
        var s = $('.yn-pdp__tick svg', root);
        if (!s) return doc.createTextNode('✓');
        var c = s.cloneNode(true); c.setAttribute('width', '16'); c.setAttribute('height', '16'); return c;
      }
      function pVariants(o, size, colour) {
        var p = o.p;
        return p.variants.filter(function (v) {
          return (!p.sizePos || v.s === size) && (!p.colourPos || v.o[p.colourPos - 1] === colour);
        });
      }
      function pStatus(o, size, colour) {
        var vs = pVariants(o, size, colour), av = vs.filter(function (v) { return v.a; });
        if (av.length) { var v = av[0]; return { out: false, v: v, left: (v.q != null && v.q >= 1 && v.q <= low) ? v.q : null }; }
        return { out: true, v: vs[0] || null, left: null };
      }
      function variantOf(o) {
        if (o.p.sizePos && !o.size) return null;
        var s = pStatus(o, o.size, o.colour);
        return s.out ? null : s.v;
      }
      function pieceFrom(p) {
        var o = { p: p, on: true, colour: null, size: null };
        if (p.colourPos && p.colours && p.colours.length) {
          var c = p.colours.filter(function (c1) { return p.variants.some(function (v) { return v.a && v.o[p.colourPos - 1] === c1.v; }); })[0];
          o.colour = c ? c.v : p.colours[0].v;
        }
        var r = remembered();
        if (r && p.sizePos && !pStatus(o, r, o.colour).out) o.size = r;
        return o;
      }
      function usable(p) { return p && p.available && p.id !== D.id && p.variants && p.variants.some(function (v) { return v.a; }); }
      function setPieces(list) {
        pieces = list.map(pieceFrom);
        if (!pieces.length) return;
        fbt.hidden = false;
        draw();
      }
      function start() {
        if (!D.available || D.kind === 'sets') return;
        var pe = $('[data-yn-fbt-pairs]', fbt), list = null;
        if (pe) { try { list = JSON.parse(pe.textContent).filter(Boolean).filter(usable); } catch (e) {} }
        if (list && list.length) { setPieces(list.slice(0, 2)); return; }
        var want = TOPS.indexOf(D.kind) > -1 ? BOTTOMS : BOTTOMS.indexOf(D.kind) > -1 ? TOPS : [];
        if (!want.length) return;
        getRecs().then(function (r) {
          var l = r.list.filter(usable).filter(function (p) { return want.indexOf(p.kind) > -1; });
          l.sort(function (a, b) { return a.price - b.price; });
          setPieces(l.slice(0, 2));
        });
      }

      function mainPiece() {
        var d = mk('div', 'yn-fbt__piece');
        var ph = mk('span', 'yn-fbt__photo'), img = mk('img');
        img.alt = ''; img.loading = 'lazy'; img.src = (cur && cur.img) || D.image || '';
        ph.appendChild(img);
        var box = mk('span', 'yn-fbt__box is-static'); box.appendChild(tickSvg()); ph.appendChild(box);
        d.appendChild(ph);
        d.appendChild(mk('span', 'yn-fbt__name', tl('This piece')));
        var pr = mk('span', 'yn-fbt__price'); pr.setAttribute('data-yn-main-price', ''); d.appendChild(pr);
        var sz = mk('span', 'yn-fbt__sizetext'); sz.setAttribute('data-yn-main-size', ''); d.appendChild(sz);
        d.setAttribute('data-yn-main-piece', '');
        return d;
      }
      function pieceEl(o, i) {
        var p = o.p, d = mk('div', 'yn-fbt__piece');
        d.setAttribute('data-i', i);
        var ph = mk('span', 'yn-fbt__photo'), img = mk('img');
        img.alt = ''; img.loading = 'lazy'; img.src = p.image || '';
        ph.appendChild(img);
        var tk = mk('button', 'yn-fbt__tick');
        tk.type = 'button'; tk.setAttribute('role', 'checkbox'); tk.setAttribute('aria-checked', 'true'); tk.setAttribute('aria-label', tl('Include [n]', { n: p.title })); tk.setAttribute('data-yn-tick', i);
        var box = mk('span', 'yn-fbt__box'); box.appendChild(tickSvg()); tk.appendChild(box);
        ph.appendChild(tk); d.appendChild(ph);
        d.appendChild(mk('span', 'yn-fbt__name', p.title + (o.colour && p.colours.length > 1 ? ' — ' + o.colour : '')));
        d.appendChild(mk('span', 'yn-fbt__price'));
        var sb = mk('button', 'yn-fbt__size'); sb.type = 'button'; sb.setAttribute('data-yn-fbt-size', i); d.appendChild(sb);
        return d;
      }
      function draw() {
        rowEl.textContent = '';
        rowEl.appendChild(mainPiece());
        pieces.forEach(function (o, i) {
          var plus = mk('span', 'yn-fbt__plus', '+'); plus.setAttribute('aria-hidden', 'true');
          rowEl.appendChild(plus);
          rowEl.appendChild(pieceEl(o, i));
        });
        drawn = true;
        refresh();
      }
      function threshold() { var c = Y().config; return (c && c.threshold) || 150000; }
      function cartTotal() { var s = Y().cart && Y().cart.state; return (s && s.total_price) || 0; }
      function refresh() {
        if (!drawn) return;
        var mp = $('[data-yn-main-piece]', rowEl);
        if (mp) {
          var img = mp.querySelector('img'), src = (cur && cur.img) || D.image || '';
          if (img && src && img.getAttribute('src') !== src) img.src = src;
          var price = cur ? cur.p : D.price, was = cur ? cur.c : D.compare;
          var pe = $('[data-yn-main-price]', mp); pe.textContent = money(price); pe.classList.toggle('is-sale', was > price);
          $('[data-yn-main-size]', mp).textContent = st.size ? tl(st.size) : tl('Your size');
        }
        pieces.forEach(function (o, i) {
          var d = $('.yn-fbt__piece[data-i="' + i + '"]', rowEl); if (!d) return;
          var v = variantOf(o), price = v ? v.p : o.p.price, was = v ? v.c : o.p.compare;
          d.classList.toggle('is-off', !o.on);
          var tk = $('[data-yn-tick]', d); tk.setAttribute('aria-checked', o.on ? 'true' : 'false');
          var pr = $('.yn-fbt__price', d); pr.textContent = money(price); pr.classList.toggle('is-sale', was > price);
          var sb = $('[data-yn-fbt-size]', d);
          sb.textContent = o.size ? tl(o.size) : tl('Pick size');
          sb.classList.toggle('is-missing', !o.size && !!o.p.sizePos);
          sb.setAttribute('aria-label', o.size ? tl('Change size, [a], [b]', { a: tl(o.size), b: o.p.title }) : tl('Pick a size, [b]', { b: o.p.title }));
          sb.hidden = !o.p.sizePos;
        });
        totals();
      }
      function totals() {
        var on = pieces.filter(function (o) { return o.on; });
        var main = cur ? cur.p : D.price;
        var total = main + on.reduce(function (a, o) { var v = variantOf(o); return a + (v ? v.p : o.p.price); }, 0);
        var count = 1 + on.length;
        var base = count === 1 ? tl('Add this piece · [n]', { n: money(total) }) : count === 2 ? tl('Add both · [n]', { n: money(total) }) : tl('Add all [a] · [b]', { a: count, b: money(total) });
        var ph = st.src === 'bundle' ? st.phase : 'idle';
        lbl.textContent = ph === 'loading' ? '' : ph === 'success' ? tl('Added!') : ph === 'error' ? tl('Try again') : base;
        addBtn.setAttribute('data-phase', ph);
        if (ph === 'error') { note.textContent = st.err; note.className = 'yn-fbt__note is-error'; return; }
        var free = isEG && cartTotal() + total >= threshold();
        note.textContent = free ? tl('With this, your order ships for free') : (isEG ? tl('Free shipping from [n]', { n: money(threshold()) }) : '');
        note.className = 'yn-fbt__note' + (free ? ' is-good' : '');
      }

      /* the piece's own size sheet */
      function drawBs() {
        if (!bsheet || !bs.o) return;
        var o = bs.o, p = o.p, body = $('[data-yn-bsheet-body]', bsheet);
        body.textContent = '';
        var wrap = mk('div', 'yn-bs');
        var top = mk('div', 'yn-bs__top'), img = mk('img', 'yn-bs__photo');
        img.alt = ''; img.src = p.image || '';
        var info = mk('div');
        info.appendChild(mk('p', 'yn-bs__name', p.title));
        info.appendChild(mk('p', 'yn-bs__price', money(p.price)));
        top.appendChild(img); top.appendChild(info); wrap.appendChild(top);
        if (p.colourPos && p.colours && p.colours.length > 1) {
          var cl = mk('p', 'yn-bs__label', tl('Colour:') + ' '); cl.appendChild(mk('b', '', bs.colour || ''));
          wrap.appendChild(cl);
          var sw = mk('div', 'yn-bs__swatches');
          sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', tl('Colour'));
          p.colours.forEach(function (c) {
            var b = mk('button', 'yn-bs__sw'); b.type = 'button';
            b.setAttribute('aria-pressed', c.v === bs.colour ? 'true' : 'false'); b.setAttribute('aria-label', c.v); b.setAttribute('data-yn-bs-colour', c.v);
            var dot = mk('span'); if (c.img) dot.style.backgroundImage = 'url("' + c.img + '")';
            b.appendChild(dot); sw.appendChild(b);
          });
          wrap.appendChild(sw);
        }
        var pills = mk('div', 'yn-bs__pills');
        pills.setAttribute('role', 'group'); pills.setAttribute('aria-label', tl('Size'));
        SIZES.concat(EXTRA_SIZES).forEach(function (label) {
          if (!p.variants.some(function (v) { return v.s === label; })) return;
          var s = pStatus(o, label, bs.colour);
          var b = mk('button', 'yn-pill yn-sz__pill' + (s.out ? ' is-soldout' : '') + (s.left ? ' is-low' : ''));
          b.type = 'button'; b.setAttribute('data-yn-bs-size', label);
          b.setAttribute('aria-pressed', bs.size === label ? 'true' : 'false');
          if (s.out) { b.disabled = true; }
          b.appendChild(doc.createTextNode(tl(label)));
          if (s.out) b.appendChild(mk('span', 'yn-vh', tl(', sold out')));
          if (!s.out && s.left) b.appendChild(mk('span', 'yn-pdp__low', tl('[n] left', { n: s.left })));
          pills.appendChild(b);
        });
        wrap.appendChild(pills);
        body.appendChild(wrap);
        var use = $('[data-yn-bsheet-use]', bsheet);
        use.disabled = !bs.size;
        use.textContent = bs.size ? tl('Use [n]', { n: tl(bs.size) }) : tl('Choose a size');
      }
      function openBs(o) {
        if (!bsheet) return;
        bs = { o: o, colour: o.colour, size: o.size };
        drawBs();
        var y = Y();
        if (y.sheet && y.sheet.open) y.sheet.open('yn-sheet-bundle');
      }
      function bundleAdd() {
        if (st.busy) return;
        if (!hasSize && !(cur && cur.a)) return;
        if (hasSize && (!st.size || selOut)) {
          if (st.size && selOut) { openSheet('pick'); return; }
          st.pending = 'bundle'; st.pendingSrc = 'bundle'; openSheet('pick'); return;
        }
        var on = pieces.filter(function (o) { return o.on; });
        var missing = on.filter(function (o) { return !variantOf(o); })[0];
        if (missing) { openBs(missing); return; }
        var items = [{ id: cur.id, quantity: 1 }].concat(on.map(function (o) { return { id: variantOf(o).id, quantity: 1 }; }));
        add(items, 'bundle');
      }

      /* events */
      listen(fbt, 'click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-yn-tick], [data-yn-fbt-size], [data-yn-fbt-add]') : null;
        if (!t) return;
        if (t.hasAttribute('data-yn-tick')) {
          var o = pieces[+t.getAttribute('data-yn-tick')]; if (!o) return;
          o.on = !o.on; refresh(); pop(t.firstChild, 1.2);
        } else if (t.hasAttribute('data-yn-fbt-size')) {
          var o2 = pieces[+t.getAttribute('data-yn-fbt-size')]; if (o2) openBs(o2);
        } else bundleAdd();
      });
      if (bsheet) {
        listen(bsheet, 'click', function (e) {
          var t = e.target.closest ? e.target.closest('[data-yn-bs-colour], [data-yn-bs-size], [data-yn-bsheet-use]') : null;
          if (!t || !bs.o) return;
          if (t.hasAttribute('data-yn-bs-colour')) {
            bs.colour = t.getAttribute('data-yn-bs-colour');
            if (bs.size && pStatus(bs.o, bs.size, bs.colour).out) bs.size = null;
            drawBs();
          } else if (t.hasAttribute('data-yn-bs-size')) {
            bs.size = t.getAttribute('data-yn-bs-size'); drawBs(); pillPop($('[data-yn-bs-size="' + bs.size + '"]', bsheet));
          } else if (bs.size) {
            bs.o.size = bs.size; bs.o.colour = bs.colour;
            var y = Y(); if (y.sheet && y.sheet.close) y.sheet.close('yn-sheet-bundle');
            var idx = pieces.indexOf(bs.o);
            if (idx > -1) {
              var d = $('.yn-fbt__piece[data-i="' + idx + '"] .yn-fbt__name', rowEl);
              if (d) d.textContent = bs.o.p.title + (bs.o.colour && bs.o.p.colours.length > 1 ? ' — ' + bs.o.colour : '');
              var im = $('.yn-fbt__piece[data-i="' + idx + '"] img', rowEl);
              var vv = variantOf(bs.o); if (im && vv && vv.img) im.src = vv.img;
            }
            refresh();
          }
        });
      }
      listen(doc, 'yuno:cart', function () { totals(); });
      return { start: start, refresh: refresh, add: bundleAdd };
    }

    /* ---------- delegated clicks ---------- */
    listen(doc, 'click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var b;
      if ((b = t.closest('[data-yn-colour]')) && root.contains(b)) { setColour(b.getAttribute('data-yn-colour'), b); return; }
      if ((b = t.closest('[data-yn-optval]')) && root.contains(b)) {
        var g = b.closest('[data-yn-opt]'); clearError();
        st.others[g.getAttribute('data-yn-opt')] = b.getAttribute('data-yn-optval'); render(); updateAlts(); return;
      }
      if ((b = t.closest('[data-yn-size]'))) {
        var inPage = pillsWrap && pillsWrap.contains(b), inSheet = sheet && sheet.contains(b);
        if (inPage || inSheet) { pickSize(b.getAttribute('data-yn-size'), b, inSheet); return; }
      }
      if ((b = t.closest('[data-yn-size-open]')) && root.contains(b)) {
        var m = b.getAttribute('data-yn-size-open');
        if (m === 'pick') { st.pending = null; st.pendingSrc = null; }
        openSheet(m); return;
      }
      if (sheet && (b = t.closest('[data-yn-size-switch]')) && sheet.contains(b)) { setMode(b.getAttribute('data-yn-size-switch')); if (b.getAttribute('data-yn-size-switch') === 'guide') loadTables(); return; }
      if (sheet && (b = t.closest('[data-yn-tab]')) && sheet.contains(b)) {
        var k = b.getAttribute('data-yn-tab'); otherTab = otherTab === k ? null : k; renderGuide(); return;
      }
      if (sheet && (b = t.closest('[data-yn-age]')) && sheet.contains(b)) { finder.age = parseInt(b.getAttribute('data-yn-age'), 10); renderFinder(); return; }
      if (sheet && (b = t.closest('[data-yn-finder-use]')) && sheet.contains(b)) {
        var sug = finderSuggest();
        if (sug && presentSizes.indexOf(sug) > -1) { pickSize(sug, null, false); toast(tl('Size set to [n]', { n: tl(sug) })); }
        return;
      }
    });
    if (sheet) {
      var hin = $('[data-yn-height]', sheet);
      if (hin) listen(hin, 'input', function () {
        var v = hin.value.replace(/[^0-9]/g, '').slice(0, 3);
        if (v !== hin.value) hin.value = v;
        finder.h = v; renderFinder();
      });
    }
    listen(doc, 'yuno:sheet:close', function (e) {
      if (e.detail && e.detail.id === 'yn-sheet-size') { st.pending = null; st.pendingSrc = null; }
    });

    /* ---------- start ---------- */
    var rs = remembered();
    if (hasSize && !st.size && rs && presentSizes.indexOf(rs) > -1 && !statusOf(rs).out) st.size = rs;
    render();
    if (hasSize) { idle(loadTables, 3000); }
    updateAlts();
    if (bundle) idle(bundle.start, 2500);

    instances.push({
      root: root,
      destroy: function () {
        cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
        if (barIO) barIO.disconnect();
        root.__ynInit = false;
      }
    });
  }

  function initAll() { $$('[data-yn-product]').forEach(init); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  doc.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-yn-product]') : null;
    if (r) init(r);
  });
  doc.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (i) {
      if (e.target && e.target.contains && e.target.contains(i.root)) { i.destroy(); return false; }
      return true;
    });
  });
})();
